module.exports = __webpack_public_path__ + "static/editroles2-35ae290c56cfa16403328244aa19734b.png";